import { useEffect, useMemo, useState } from 'react';
import { useInstantSearch } from 'react-instantsearch';

type FacetItem = {
  label: string;
  value: string;
  count: number;
  isRefined: boolean;
};

export function useResultsHeaderData(
  facetBuckets: FacetItem[],
  nbHits: number,
) {
  const { indexUiState } = useInstantSearch();
  const trimmedQuery = (indexUiState?.query || '').trim();

  const anyRefined = facetBuckets.some((b) => b.isRefined);
  const [initialHitCount, setInitialHitCount] = useState(0);

  useEffect(() => {
    if (!trimmedQuery) {
// eslint-disable-next-line react-hooks/exhaustive-deps
      setInitialHitCount(0)
      return;
    }
    if (!anyRefined) setInitialHitCount(nbHits);
  }, [trimmedQuery, anyRefined, nbHits]);

  const activeFacet = useMemo(
    () => facetBuckets.find((b) => b.isRefined),
    [facetBuckets],
  );

  return { trimmedQuery, activeFacet, initialHitCount };
}
